module.exports = __webpack_public_path__ + "mpr.1eb0d585628ce109a4cf70cb83fc8e2e.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/images/mpr.png
// module id = ./frontend/images/mpr.png
// module chunks = 1